import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

// 路由白名单
const whiteList = ['/login'];

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('./views/Home.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: 'product',
          name: 'Product',
          component: () => import('./views/Product.vue'),
          meta: { title: '产品库' },
          children: [
            {
              path: 'manage',
              name: 'ProductManage',
              component: () => import('./views/ProductManage.vue'),
              meta: { title: '产品管理' },
            },
            {
              path: 'add',
              name: 'ProductAdd',
              component: () => import('./views/ProductAdd.vue'),
              meta: { title: '产品添加' },
            },
            {
              path: 'industry',
              name: 'ProductIndustry',
              component: () => import('./views/ProductIndustry.vue'),
              meta: { title: '行业管理' },
            },
          ],
        },
        {
          path: 'guide',
          name: 'Guide',
          component: () => import('./views/Guide.vue'),
          meta: { title: '新手入门' },
          children: [
            {
              path: 'manage',
              name: 'GuideManage',
              component: () => import('./views/GuideManage.vue'),
              meta: { title: '新手入门管理' },
            },
            {
              path: 'add',
              name: 'GuideAdd',
              component: () => import('./views/GuideAdd.vue'),
              meta: { title: '添加步骤' },
            },
          ],
        },
        {
          path: 'demo',
          name: 'Demo',
          component: () => import('./views/Demo.vue'),
          meta: { title: '作品示范' },
          children: [
            {
              path: 'manage',
              name: 'DemoManage',
              component: () => import('./views/DemoManage.vue'),
              meta: { title: '作品示范管理' },
            },
            {
              path: 'add',
              name: 'DemoAdd',
              component: () => import('./views/DemoAdd.vue'),
              meta: { title: '添加作品' },
            },
            {
              path: 'industry',
              name: 'DemoIndustry',
              component: () => import('./views/DemoIndustry.vue'),
              meta: { title: '行业管理' },
            },
          ],
        },
      ],
    },
  ],
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (whiteList.includes(to.path)) {
    next();
  } else if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (token) {
      next();
    } else {
      next('/login');
    }
  } else {
    next();
  }
});

export default router;
